var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// aspect-schemas/IntAspect.ts
import { Int } from "@adornis/baseql/baseqlTypes.js";
import { Entity, Field } from "@adornis/baseql/decorators.js";
import { registerEntity } from "@adornis/baseql/metadata/register.js";
import { html } from "lit";
import { getMongoRangeFilter } from "../range-helper.js";
import { AbstractAspect } from "./AbstractAspect.js";
var modeDisplay = {
  equals: "Ist gleich",
  range: "Ist zwischen",
  isHigher: "Ist gr\xF6\xDFer-gleich",
  isLower: "Ist kleiner-gleich"
};
var IntAspect = class extends AbstractAspect {
  constructor(doc) {
    super(doc);
  }
  getMongoFilter() {
    const { min, max, fieldName } = this;
    if (!fieldName)
      return null;
    switch (this.mode) {
      case "equals":
        return { [fieldName]: { $eq: min } };
      case "range":
        return getMongoRangeFilter({ min, max, fieldName });
      case "isHigher":
        return { [fieldName]: { $gte: min } };
      case "isLower":
        return { [fieldName]: { $lte: min } };
    }
  }
};
IntAspect._class = "IntAspect";
__decorateClass([
  Field((type) => Int)
], IntAspect.prototype, "min", 2);
__decorateClass([
  Field((type) => Int)
], IntAspect.prototype, "max", 2);
__decorateClass([
  Field((type) => String, { default: (v) => v ?? "equals" })
], IntAspect.prototype, "mode", 2);
IntAspect = __decorateClass([
  Entity()
], IntAspect);
var IntAspectSchema = (mode) => {
  class IntVariationAspect extends IntAspect {
    constructor(doc) {
      doc.mode = mode;
      super(doc);
    }
  }
  IntVariationAspect._class = `Int${mode.toUpperCase()}Aspect`;
  registerEntity(IntVariationAspect);
  const IntModeConfig = {
    aspectConstructor: IntVariationAspect,
    renderEditor: ({ aspectValue }) => aspectValue.mode === "range" ? html`
            <x-flex horizontal space="sm">
              <x-input
                step="1"
                type="number"
                clearable
                placeholder="Größer-gleich"
                placeholder-mode="hide"
                .value=${aspectValue.min}
                @value-picked=${(e) => aspectValue.min = e.detail.value}
              ></x-input>
              <x-input
                step="1"
                type="number"
                clearable
                placeholder="Kleiner-gleich"
                placeholder-mode="hide"
                .value=${aspectValue.max}
                @value-picked=${(e) => aspectValue.max = e.detail.value}
              ></x-input>
            </x-flex>
          ` : html`
            <x-input
              step="1"
              type="number"
              clearable
              placeholder="Zahl"
              placeholder-mode="hide"
              .value=${aspectValue.min}
              @value-picked=${(e) => aspectValue.min = e.detail.value}
            ></x-input>
          `,
    renderPreview: ({ aspectValue }) => aspectValue.min ? html` ${aspectValue.min} ` : null
  };
  return IntModeConfig;
};
var IntVariations = Object.keys(modeDisplay).map(
  (mode) => IntAspectSchema(mode)
);
export {
  IntAspect,
  IntAspectSchema,
  IntVariations
};
